import {
  getV1RutterConnectionsConnectionIdVendors,
  GetV1RutterConnectionsConnectionIdVendorsData,
  Rutter_Vendor_Read,
} from '@treadinc/horizon-api-spec';
import { FieldValues } from 'react-hook-form';

import { RutterMappedRecord, RutterVendor } from '~hooks/useRutter/models';

import AsyncAutocompleteField from '../v2/Autocomplete/AsyncAutocompleteField';
import { CommonAsyncAutocompleteFieldProps } from '../v2/Autocomplete/types';

type Props<T extends FieldValues> = CommonAsyncAutocompleteFieldProps<
  T,
  Rutter_Vendor_Read,
  RutterMappedRecord,
  GetV1RutterConnectionsConnectionIdVendorsData
> & { companyId: string; connectionId: string };

// Offers only the QuickBooks vendors not yet mapped to a Tread account.
export default function AutocompleteRutterVendorsTypeahead<T extends FieldValues>({
  companyId,
  connectionId,
  ...rest
}: Props<T>) {
  return (
    <AsyncAutocompleteField
      {...rest}
      queryName="AutocompleteRutterVendorsTypeahead"
      fetchFn={{
        arguments: {
          path: { 'company-id': companyId, 'connection-id': connectionId },
          query: { 'filter[unmapped]': true },
        },
        request: getV1RutterConnectionsConnectionIdVendors,
      }}
      filterOptions={(options) => options.filter(({ _entity }) => _entity.isActive)}
      parseFn={(item: Rutter_Vendor_Read) => {
        const vendor = RutterVendor.parse(item);
        const name = vendor.rutterApiVendor.vendor_name ?? '';

        return {
          _entity: new RutterMappedRecord(vendor.id, name, vendor.isActive),
          label: name,
          value: vendor.id,
        };
      }}
    />
  );
}
